require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/object/keys.js
// module id = AQhR
// module chunks = 0